module.exports = __webpack_public_path__ + "753f8e9bb196ab24bd4f3c73a8289faa.svg";